/**
 * A janela que a demo serve, e as fronteiras de instrumentacao que decidem
 * QUAIS dias podem ser oferecidos ao lado dela.
 *
 * Fica aqui, e nao no componente, porque o health check precisa verificar
 * EXATAMENTE a mesma janela que a tela pede. Duas copias divergiriam em silencio,
 * e ai o health passaria a dizer "saudavel" sobre uma janela que ninguem consome.
 */
export const DEMO_WINDOW = {
	day: '2026-08-11',
	from: '06:00',
	to: '09:00',
	lines: ['1758', '1759'] as const,
} as const

/**
 * Primeiro dia com cadencia de coleta de 60 s.
 *
 * MEDIDO em `posicoes` (intervalo entre lotes distintos, dia a dia): ate 04/08 a mediana
 * e de 300 s, com 136 lotes por dia; 05/08 tem 1.097 lotes a 60 s exatos comecando
 * 05:43:35; de 06/08 a 21/08, 1.440 lotes por dia a 60 s.
 *
 * POR QUE ISSO CORTA A LISTA: a duracao de uma viagem medida com amostra de 5 em 5 min
 * sai inflada, porque o inicio e o fim so podem ser cravados dentro do balde de 300 s.
 * Oferecer 04/08 ao lado de 11/08 seria oferecer dois instrumentos como se fossem um.
 * Nao ha correcao para isso na tela: o dia simplesmente nao entra.
 */
export const CADENCE_60S_DAY = '2026-08-05'

/**
 * Dia em que a ingestao passou a guardar grupos (linha, sentido) com UM veiculo so.
 *
 * Antes disso, todo minuto em que uma linha tinha um unico onibus era descartado na
 * ingestao. MEDIDO no corredor: zero grupos de 1 veiculo ate 19/08 as 20h; 298 na hora
 * das 21h de 19/08; 640 no dia inteiro de 20/08.
 *
 * RESSALVA IMPORTANTE, e a razao de isto ser um AVISO e nao um corte: na janela de
 * 06h as 09h o defeito nao aparece. Medido dia a dia de 05/08 a 20/08, o corredor tem
 * ZERO grupos de 1 veiculo nessa faixa em todos os dias - no pico da manha nunca ha um
 * onibus sozinho. O descarte mordia madrugada e noite. Entao, para a janela desta demo,
 * os dias dos dois lados da fronteira sao comparaveis; para um dia inteiro, nao.
 */
export const SINGLE_VEHICLE_DAY = '2026-08-19'
export const SINGLE_VEHICLE_HOUR_SP = '21:00'

/**
 * Primeiro dia em que o detector de viagens da fonte PAROU DE REJEITAR registro.
 *
 * MEDIDO em `motivo_incompleta` das linhas 1758/1759: ate 17/08 a coluna carrega os
 * motivos de recusa do detector - `dist 0.000km < 0.05km` (cerca de 50 por dia),
 * `apenas 1/2 pontos GPS (min 3)` (10 a 19) e duracao abaixo de 0,4x a mediana movel
 * (cerca de 20). A partir de 18/08 os tres somem e sobram so dois valores, nulo e
 * `Jornada cortada no fim dos dados`. Consequencia: 100,0% dos registros passam a ser
 * marcados validos, contra 75,8% a 82,5% ate 17/08.
 *
 * ESTA e a fronteira que importa nesta base, e ela e invisivel para quem confere pelo
 * total: o numero de registros do dia continua em ~375 a 400 dos dois lados. O que mudou
 * foi a composicao. Prova pela geometria: entre os registros marcados completos, os que
 * andaram menos de 500 m eram 1,0% a 1,8% ate 17/08 e viram 5,7%, 7,1% e 10,6% em 18,
 * 19 e 20/08.
 *
 * A demo NAO depende dessa bandeira (ver VIAGEM_VALIDA em queries/trips.ts, que mede
 * distancia, pontos e duracao no proprio registro). A data continua aqui porque o
 * seletor precisa dizer de que lado da mudanca cada dia esta - o dado bruto e o mesmo,
 * mas o que a fonte afirma sobre ele nao e.
 */
export const SOURCE_STOPPED_REJECTING_DAY = '2026-08-18'

/** Nomes dos dias da semana em pt-BR, indexados por `Date#getUTCDay()`. */
export const WEEKDAY_PT = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado']

/** Nome do dia da semana de uma data AAAA-MM-DD, lida como data civil (sem fuso). */
export function weekdayPt(day: string): string {
	return WEEKDAY_PT[new Date(`${day}T00:00:00Z`).getUTCDay()]
}

/** `AAAA-MM-DD` como `DD/MM`. */
export function shortDatePt(day: string): string {
	const [, m, d] = day.split('-')
	return `${d}/${m}`
}
